$(function() {
  var pagetop = $('#js-pagetop')
  var btn = $('#js-pagetop-btn')
  $(window).scroll(function() {
    if ($(this).scrollTop() > 100) {
      pagetop.removeAttr('aria-hidden')
    } else {
      pagetop.attr('aria-hidden', 'true')
    }
  })
  btn.click(function() {
    $('body,html').animate(
      {
        scrollTop: 0
      },
      500
    )
    return false
  })
})

$(window).on('scroll', function() {
  var documentHeight = $(document).height()
  var scrollPosition = $(this).height() + $(this).scrollTop()
  var footerHeight = $('#js-footer-copyright').innerHeight()

  if (documentHeight - scrollPosition <= footerHeight) {
    $('#js-pagetop').css({
      position: 'absolute',
      bottom: footerHeight + 8
    })
  } else {
    $('#js-pagetop').css({
      position: 'fixed',
      bottom: 8
    })
  }
})
